import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { SubActivityType } from "../../redux/residentActivityPlan";
import { iconMeasurement } from "../../utils/AlertTo";
import { Dialog } from "@material-ui/core";
import { useSwipeable } from "react-swipeable";

export type saveData = {
  key: SubActivityType;
  value: string;
};
const VitalSignsWrap = ({
  params,
  onSave,
  errorObj,
}: {
  params: SubActivityType[];
  onSave: (values: saveData[]) => void;
  errorObj: string[];
}): JSX.Element => {
  const tStatus = useTranslation("status").t;
  const [valuesInput, setvaluesInput] = useState<saveData[]>(
    params.map((el) => {
      return { key: el, value: "" };
    })
  );

  // const [valuesError, setvaluesError] = useState(reminder?.activityParams.map((el) => ''));
  const onValuesChange = useCallback(
    (value: string, type: SubActivityType, index: number) => {
      const regexWithDot = /^[0-9.]*$/;
      const regexSlash = /^[0-9/]*$/;
      const regexOnlyNumbers = /^[0-9]*$/;
      switch (type) {
        case SubActivityType.BLOOD_PRESSURE:
          if (!regexSlash.test(value)) {
            value = value.slice(0, -1);
          }
          break;
        case SubActivityType.TEMPERATURE:
          if (!regexWithDot.test(value)) {
            value = value.slice(0, -1);
          }
          break;
        default:
          if (!regexOnlyNumbers.test(value)) {
            value = value.slice(0, -1);
          }
      }

      const newVals = [...valuesInput];
      newVals[index].value = value;
      setvaluesInput([...newVals]);
      onSave(newVals);
    },
    [valuesInput, onSave]
  );
  const [editedValue, seteditedValue] = useState(undefined);
  const onShowForm = useCallback((type, index) => {
    seteditedValue({ type, index });
  }, []);
  const onSubmitForm = useCallback((e) => {
    e.preventDefault();
    seteditedValue(undefined);
  }, []);
  const handlers = useSwipeable({
    onSwipedRight: () => seteditedValue(undefined),
  });
  return (
    <>
      {params?.map((el: SubActivityType, index) => (
        <div
          className={`form-control flex-row flex-between ${
            valuesInput[index]?.value ? "setted" : ""
          }`}
          style={{
            border: errorObj[index] ? "1px solid #FF3B30" : "",
            background: errorObj[index] ? "black" : "",
          }}
          key={el}
          onClick={() => onShowForm(el, index)}
        >
          <div className="flex-gap">
            <i
              className={iconMeasurement(el)}
              style={{ color: errorObj[index] !== "" ? "#FF3B30" : "" }}
            />
            <span>{tStatus(el)}</span>
          </div>

          <div
            className={`input-wrap ${errorObj[index] !== "" ? "error " : ""}`}
            style={{
              marginBottom: "0px",
              maxWidth: "112px",
            }}
          >
            <span
              className="value"
              style={{ color: errorObj[index] !== "" ? "#E85658" : "" }}
            >
              {valuesInput[index]?.value}
            </span>
          </div>
        </div>
      ))}
      <Dialog
        open={editedValue !== undefined}
        fullScreen={true}
        onClose={() => seteditedValue(undefined)}
      >
        <form onSubmit={onSubmitForm} {...handlers}>
          <input
            className="vitals-signs"
            value={valuesInput[editedValue?.index]?.value || ""}
            maxLength={7}
            required
            type="number"
            autoFocus
            onChange={(evt) =>
              onValuesChange(
                evt.target.value,
                editedValue?.type,
                editedValue?.index
              )
            }
          ></input>
          {errorObj[editedValue?.index] !== "" && (
            <span className="error-span">
              {tStatus(errorObj[editedValue?.index])}
            </span>
          )}
        </form>
      </Dialog>
    </>
  );
};
export const validateValues = (values: saveData[]): string[] => {
  const errorObj = values.map((el) => "");
  values.map((el: saveData, index) => {
    if (el.value !== "") {
      switch (el.key) {
        case SubActivityType.BLOOD_PRESSURE:
          if (
            el.value.indexOf("/") === 0 ||
            el.value.indexOf("/") !== el.value.lastIndexOf("/")
          )
            errorObj[index] = "Wrong value";
          const before = el.value.slice(0, el.value.indexOf("/"));
          const after = el.value.slice(el.value.indexOf("/") + 1);
          if (!before.match(/[0-9]/) || !after.match(/[0-9]/))
            errorObj[index] = "Wrong value";
          if (
            isNaN(parseInt(before)) ||
            parseInt(before) > 500 ||
            parseInt(before) < 10 ||
            isNaN(parseInt(after)) ||
            parseInt(after) < 10 ||
            parseInt(after) > 500
          )
            errorObj[index] = "Wrong value";

          break;
        case SubActivityType.HEART_RATE:
          if (!el.value.match(/[0-9]/)) errorObj[index] = "Wrong value";
          if (
            isNaN(parseInt(el.value)) ||
            parseInt(el.value) > 400 ||
            parseInt(el.value) < 10
          )
            errorObj[index] = "Wrong value";
          break;
        case SubActivityType.SPO2:
          if (!el.value.match(/[0-9]/)) errorObj[index] = "Wrong value";
          if (
            isNaN(parseInt(el.value)) ||
            parseInt(el.value) > 100 ||
            parseInt(el.value) < 20
          )
            errorObj[index] = "Wrong value";
          break;
        case SubActivityType.TEMPERATURE:
          if (el.value.indexOf(".") === -1) {
            if (
              isNaN(parseInt(el.value)) ||
              parseInt(el.value) > 100 ||
              parseInt(el.value) < 20
            )
              errorObj[index] = "Wrong value";
          } else {
            if (
              el.value.indexOf(".") < 2 ||
              el.value.indexOf(".") !== el.value.lastIndexOf(".")
            )
              errorObj[index] = "Wrong value";
            const before = el.value.slice(0, el.value.indexOf("."));
            const after = el.value.slice(el.value.indexOf(".") + 1);
            if (!before.match(/[0-9]/) || !after.match(/[0-9]/))
              errorObj[index] = "Wrong value";
            if (
              isNaN(parseInt(before)) ||
              parseInt(before) > 50 ||
              parseInt(before) < 20 ||
              isNaN(parseInt(after)) ||
              parseInt(after) < 0 ||
              parseInt(after) > 9
            )
              errorObj[index] = "Wrong value";
            break;
          }
      }
    }
    return null;
  });
  return errorObj;
};
export default React.memo(VitalSignsWrap);
